// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Line } from './line';
import { Mesh } from './mesh';
import { Plane } from './plane';
import { Polyline } from './polyline';
import { Vector } from './vector';


export class DataFlowVertexData {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):DataFlowVertexData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDataFlowVertexData(bb:flatbuffers.ByteBuffer, obj?:DataFlowVertexData):DataFlowVertexData {
  return (obj || new DataFlowVertexData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDataFlowVertexData(bb:flatbuffers.ByteBuffer, obj?:DataFlowVertexData):DataFlowVertexData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new DataFlowVertexData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static bufferHasIdentifier(bb:flatbuffers.ByteBuffer):boolean {
  return bb.__has_identifier('DFVD');
}

models(index: number, obj?:Mesh):Mesh|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new Mesh()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

modelsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

polylines(index: number, obj?:Polyline):Polyline|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Polyline()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

polylinesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

points(index: number, obj?:Vector):Vector|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new Vector()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

pointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

lines(index: number, obj?:Line):Line|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new Line()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

linesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

planes(index: number, obj?:Plane):Plane|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new Plane()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

planesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startDataFlowVertexData(builder:flatbuffers.Builder) {
  builder.startObject(5);
}

static addModels(builder:flatbuffers.Builder, modelsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, modelsOffset, 0);
}

static createModelsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startModelsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addPolylines(builder:flatbuffers.Builder, polylinesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, polylinesOffset, 0);
}

static createPolylinesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPolylinesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addPoints(builder:flatbuffers.Builder, pointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, pointsOffset, 0);
}

static createPointsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addLines(builder:flatbuffers.Builder, linesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, linesOffset, 0);
}

static createLinesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startLinesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addPlanes(builder:flatbuffers.Builder, planesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, planesOffset, 0);
}

static createPlanesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPlanesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endDataFlowVertexData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishDataFlowVertexDataBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'DFVD');
}

static finishSizePrefixedDataFlowVertexDataBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'DFVD', true);
}

static createDataFlowVertexData(builder:flatbuffers.Builder, modelsOffset:flatbuffers.Offset, polylinesOffset:flatbuffers.Offset, pointsOffset:flatbuffers.Offset, linesOffset:flatbuffers.Offset, planesOffset:flatbuffers.Offset):flatbuffers.Offset {
  DataFlowVertexData.startDataFlowVertexData(builder);
  DataFlowVertexData.addModels(builder, modelsOffset);
  DataFlowVertexData.addPolylines(builder, polylinesOffset);
  DataFlowVertexData.addPoints(builder, pointsOffset);
  DataFlowVertexData.addLines(builder, linesOffset);
  DataFlowVertexData.addPlanes(builder, planesOffset);
  return DataFlowVertexData.endDataFlowVertexData(builder);
}
}
